import { render, staticRenderFns } from "./AdminAppBar.vue?vue&type=template&id=725c2ea2&scoped=true"
import script from "./AdminAppBar.vue?vue&type=script&lang=js"
export * from "./AdminAppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725c2ea2",
  null
  
)

export default component.exports